// Single source of truth for building image URLs (posters, stills, profiles).
//
// Every component used to hardcode `https://image.tmdb.org/t/p/wNNN`. Centralizing
// the host here makes Stage 3b (serving images from our own CDN instead of
// hotlinking TMDB) a one-env-var cutover: set REACT_APP_IMAGE_CDN_BASE to our
// CloudFront origin and every call site follows. The default reproduces the
// previous TMDB behavior exactly.

export const IMAGE_CDN_BASE =
  process.env.REACT_APP_IMAGE_CDN_BASE || 'https://image.tmdb.org/t/p';

// Build a full image URL from a TMDB-style path ("/abc.jpg"), at the given size
// bucket (w92 / w200 / w300 / w500 / original ...). Returns '' for a falsy path.
// A value that is already an absolute URL is returned unchanged — some API rows
// already contain full image URLs.
export function imageUrl(path, size = 'w500') {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${IMAGE_CDN_BASE}/${size}${path}`;
}

// Strip a known image base back to a bare "/abc.jpg" path, for normalizing a
// full URL before persisting it (e.g. local-storage bookmarks). A value that is
// already a bare path, or on an unrecognized host, is returned unchanged.
export function stripImageBase(url) {
  if (!url) return url;
  // Remove our CDN base or any TMDB /t/p/<size> prefix, leaving the bare path.
  return url
    .replace(new RegExp(`^${IMAGE_CDN_BASE}/[^/]+`), '')
    .replace(/^https?:\/\/image\.tmdb\.org\/t\/p\/[^/]+/, '');
}
